import Modal from "../ui/Modal";
import { useGetDistributorByIdQuery } from "../../redux/api/distributor";
import { useLanguage } from "../../contexts/LanguageContext";
import { useFormatters } from "../../hooks/useFormatters";
import LoadingSpinner, { FullPageLoader } from "../ui/LoadingSpinner";

const DistributorDetailModal = ({ id, isOpen, onClose }) => {
  const { t } = useLanguage();
  const { formatCurrency } = useFormatters();
  const {
    data: distributor,
    isLoading,
    isFetching,
    isError,
  } = useGetDistributorByIdQuery(id, {
    skip: !id || !isOpen,
    refetchOnMountOrArgChange: true,
  });

  // Use mockdata if no id is provided
  const data = distributor;

  const validateAddressValue = (value) => {
    if (value === "รอข้อมูล" || value === "" || value === null) return "-";
    return value;
  };

  if (!isOpen) return null;
  if (id && (isLoading || isFetching))
    return <FullPageLoader size="md" text={t("common.loading")} />;
  if ((id && isError) || !data)
    return (
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title={t("common.customerInfo")}
        size="md"
      >
        <div className="p-6 text-center text-red-600">
          {t("customer.empty")}
        </div>
      </Modal>
    );

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={data.name || "-"} size="md">
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="grid grid-cols-1">
          <div className="space-y-4">
            <div>
              <h3 className="font-semibold mb-2">{t("distributor.distributorInfo")}</h3>
              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span className="text-muted-foreground">
                    {t("distributor.code", "Code")}
                  </span>
                  <span className="font-medium">{data.code}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">
                    {t("distributor.prefix", "Prefix")}
                  </span>
                  <span>{data.prefix || "-"}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">
                    {t("distributor.addressLine1")} 
                  </span>
                  <span>{validateAddressValue(data.addr1)}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">
                    {t("distributor.addressLine2")} 
                  </span>
                  <span>{validateAddressValue(data.addr2)}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">
                    {t("distributor.addressLine3")} 
                  </span>
                  <span>{validateAddressValue(data.addr3)}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">
                    {t("distributor.addressLine4")} 
                  </span>
                  <span>{validateAddressValue(data.addr4)}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">
                    {t("distributor.addressLine5")} 
                  </span>
                  <span>{validateAddressValue(data.addr5)}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">
                    {t("customer.postalCode")}
                  </span>
                  <span>{data.postalCode || "-"}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">
                    {t("customer.taxRegNo")}
                  </span>
                  <span>{data.taxId || "-"}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">
                    {t("customer.contactPerson")}
                  </span>
                  <span>{data.contactName || "-"}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">
                    {t("distributor.contactAdmin") || "Contact Admin"}
                  </span>
                  <span>{data.contactAdmin || "-"}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">
                    E-Mail
                  </span>
                  <span>{data.email || "-"}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
export default DistributorDetailModal;
